export default __webpack_public_path__ + "static/media/icon2.eb64a41e.png";